import {useState,useEffect, useRef} from 'react'
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { Star } from 'react-feather';
import util from '@utils/utils';
import { checkLoginAndExecute, shouldShowLoginUI } from '@utils/authUtils';
import {MarkModal} from '../../components/MarkModal'
import useGetSavedFoldList from '../../hooks/useGetSavedFoldList';
import {FileContentModal} from './components/FileContentModal'
import { SearchInput} from './components/SearchInput'
import { HomeRecommends } from './components/HomeRecommends'
import { HomeStatsA } from './components/HomeStats/HomeStatsA'
import { HomeStatsB } from './components/HomeStats/HomeStatsB'
import {FullScreenMindTreeModal} from '@components/FullScreenMindTreeModal'
import useGetOrgAndNum from './hooks/useGetOrgAndNum';
import useGetPdf from '@hooks/useGetPdf';
import { useConfig } from '../../contexts/ConfigContext';

export const Policy = (props) => {
    const mountCountRef = useRef(0);
    const [input,setInput] =useState('')
    const [markData, setMarkData] = useState()
    const {savedFoldListLoading, savedFoldListData, savedFoldListRefresh} = useGetSavedFoldList()
    const {orgAndNumLoading,orgAndNumData} = useGetOrgAndNum()
    
    // ✅ 添加挂载监控
    // 在第25行的 useEffect 中添加更多信息
    useEffect(() => {
        mountCountRef.current += 1;
        
        return () => {
        };
    }, []);
    const [fileName, setFileName] = useState()
    const [fileId, setFileId] = useState()
    const [mdTxt,setMdTxt] =useState('')
    const navigate = useNavigate();
    const [searchK,setSearchK] = useState('')
    const [searchOrg,setSearchOrg] = useState('')
    const {getPdfLoading,getPdfData,getPdfAction} = useGetPdf()
    const { clientId } = useConfig();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    
    // 检查登录状态
    useEffect(() => {
        // ✅ 获取当前环境 - 优先使用config中的clientId，否则从util获取
        const currentClientId = clientId || util.getCurrentClientId();
        
        // ✅ 根据环境设置登录状态
        if (currentClientId === 'client-a') {
            // a环境：确保有用户信息并设置为已登录
            util.ensureUserInfo();
            setIsLoggedIn(true);
        } else {
            // b环境：检查实际登录状态
            setIsLoggedIn(util.isUserLoggedIn());
        }
    }, [clientId]); // 依赖clientId
    
    // ✅ 使用统一的登录检查函数
    const handleLoginRequired = (action, options = {}) => {
        return checkLoginAndExecute(action, options);
    };
    
    // ✅ 获取当前环境用于条件渲染
    const currentClientId = clientId || util.getCurrentClientId();

    // ✅ 首页触发搜索时，跳转到搜索页
    useEffect(() => {
        if (searchK || searchOrg) {
            navigate(`/policy/search?k=${encodeURIComponent(searchK)}&org=${encodeURIComponent(searchOrg)}`);
        }
    }, [searchK, searchOrg, navigate]);
    
    return (
        <>
            <FullScreenMindTreeModal
                fileName={fileName}
                txt={mdTxt}
                setFileName={setFileName}
                setMdTxt={setMdTxt}
            />
            <MarkModal
                markData={markData}
                loading={savedFoldListLoading}
                data={savedFoldListData}
                savedFoldListRefresh={savedFoldListRefresh}
            />
            <FileContentModal
                getPdfAction={getPdfAction}
                fileName={fileName}
                searchContent={input}
                fileId={fileId}
                setFileName={setFileName}
                setMdTxt={setMdTxt}
                savedFoldListData={savedFoldListData}
                setMarkData={setMarkData}
                handleLoginRequired={handleLoginRequired}
            />
            <div className={`flex flex-col h-full overflow-auto ${clientId === 'client-b' ? 'mainContainer' : ''}`}>
                <SearchInput
                    input={input}
                    orgAndNumLoading={orgAndNumLoading}
                    orgAndNumData={orgAndNumData}
                    setInput={setInput}
                    setSearchK={setSearchK}
                    large
                    rounded
                    shadow
                />
                <div className='md:flex px-2 md:px-12 lg:px-24 2xl:px-36 3xl:px-48'>
                    <div className={`${currentClientId === 'client-a' ? 'md:w-[70%]' : 'md:w-[80%]'}`}>
                        <HomeRecommends
                            getPdfAction={getPdfAction}
                            fileName={fileName}
                            setFileName={setFileName}
                            setFileId={setFileId}
                            setMarkData={setMarkData}
                            savedFoldListData={savedFoldListData}
                            setMdTxt={setMdTxt}
                            handleLoginRequired={handleLoginRequired}
                        />
                    </div>
                    {currentClientId === 'client-a' ? (
                        <HomeStatsA
                            setSearchOrg={setSearchOrg}
                            orgAndNumData={orgAndNumData?.fixed_result}
                        />
                    ) : (
                        <HomeStatsB
                            setSearchOrg={setSearchOrg}
                            orgAndNumData={orgAndNumData?.fixed_result}
                        />
                    )}
                </div>
            </div>
            {/* 只有登录用户才显示收藏夹按钮 */}
            {shouldShowLoginUI() && (
                <div className='fixed bottom-32 right-6'>
                    <button
                        className="bg-base-100 group btn hover:btn-primary hover:text-white shadow-lg h-4"
                        onClick={() => handleLoginRequired(() => navigate('/collections'))}
                    >
                        <Star size='1.5rem'/>
                        <span className='group-hover:block hidden'>收藏夹</span>
                    </button>
                </div>
            )}
        </>
    )
}

